const Module = {
  DASHBOARD: 'dashboard',
  LEAVES: 'leaves',
  ATS_DASHBOARD: 'ats_dashboard',
  EXPENSES: 'expenses',
  TIME_ENTRIES: 'timeEntries',
  APPROVAL_LEAVES: 'approvalLeaves',
  APPROVAL_EXPENSES: 'approvalExpenses',
  APPROVAL_TIME_ENTRIES: 'approvalTimeEntries',
  POLICIES: 'policies',
  PRE_DEFINED_REPORTS: 'preDefinedReports',
  CUSTOM_REPORTS: 'customReports',
  USER_MANAGEMENT: 'userManagement',
  TIMESHEET_CONFIGURATION: 'timesheetConfiguration',
  EMAIL_TEMPLATES: 'emailTemplates',
  ORGANIZATION_SETUP: 'organizationSetup',
  ALL_APPROVAL_TIME_ENTRIES: 'allApprovalTimeEntries',
  ALL_APPROVAL_EXPENSES: 'allApprovalExpenses',
  ALL_APPROVAL_LEAVES: 'allApprovalLeaves',
  ATS_RECRUITER: 'atsRecruiter',
  ATS_RECRUITER_ADMIN: 'atsRecruiterAdmin',
  ATS_INTERVIEWER: 'ATSInterviewer',
  VR_ASSISTANT: 'vrAssistant',
  ORGANIZATIONS: 'organizations',
  /**
   * Module for viewing Dice profiles in the ATS system
   */
  DICE_ATS_PROFILE_VIEW: 'ats_dice_ats_profile_view',

  /**
   * Module for accessing the Dice search functionality
   * Allows users to search for candidates in the Dice database
   */
  DICE_SEARCH: 'ats_dice_search',

  /**
   * Module for accessing the Dice jobs page
   * Allows users to view and manage job postings on Dice
   */
  DICE_JOBS: 'ats_dice_jobs',

  /**
   * Module for accessing the Dice dashboard
   * Provides analytics and overview of Dice-related activities
   */
  DICE_DASHBOARD: 'ats_dice_dashboard',

  /**
   * Module for accessing the Dice history page
   * Shows historical data and past activities related to Dice
   */
  DICE_HISTORY: 'ats_dice_history',

  /**
   * Module for accessing the Talent Pool feature
   * Allows management of candidate database and talent acquisition
   */
  TALENT_POOL: 'ats_talent_pool',

  /**
   * Access control for vendor profile management in C2C onboarding flow.
   * Both recruiters and HR personnel can create and manage vendor profiles.
   */
  VENDORS: 'vendors',

} as const;

export type ModuleType = typeof Module[keyof typeof Module];

export {
  Module,
};
